/*
 * @Author: aalizzwell 
 * @Date: 2019-05-30 14:12:39 
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-05-30 16:18:47
 */
import { ParentTreeNodeUtil } from './parent-tree.util';
import { PathTreeNodeUtil } from './path-tree.util';

export class TreeUtilFactory {
  static getInstance(treeType: string) {
    let util = null;
    switch (treeType) {
      case 'path':
        util = new PathTreeNodeUtil();
        break;
      case 'parent':
        util = new ParentTreeNodeUtil();
        break;
      default: break;
    }
    return util;
  }
}